import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
const Review3DIcon = (t0)=>{
    const $ = c(7);
    const { width, height, color } = t0;
    let t1;
    if ($[0] !== color) {
        t1 = /*#__PURE__*/ jsx("g", {
            filter: "url(#filter0_i_3982_59685)",
            children: /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.0941 10.5067L36.3297 6.5134C36.3497 6.49475 36.3631 6.48743 36.3676 6.48526C36.3727 6.48284 36.377 6.48152 36.3824 6.48073C36.3951 6.47886 36.423 6.47921 36.4582 6.49448C36.4934 6.50976 36.5134 6.5302 36.5213 6.54168C36.5247 6.5466 36.527 6.55114 36.5288 6.55685C36.5304 6.56204 36.5343 6.57638 36.5343 6.60411V9.60939C36.5343 10.6035 37.3402 11.4094 38.3343 11.4094H41.2975C41.3268 11.4094 41.3419 11.4135 41.3473 11.4152C41.3532 11.4171 41.3574 11.4192 41.3617 11.4222C41.3718 11.4292 41.3905 11.4474 41.4043 11.4799C41.4182 11.5124 41.4179 11.5372 41.4163 11.5472C41.4163 11.5472 41.4157 11.5501 41.4146 11.5534C41.414 11.5554 41.4133 11.5575 41.4124 11.5591C41.4124 11.5591 41.4035 11.5761 41.3838 11.5966L41.3789 11.6016L37.3191 15.8406L37.3106 15.8496C37.3106 15.8496 37.2993 15.8601 37.2842 15.8664C37.2688 15.873 37.2522 15.8762 37.2377 15.8762H33.3995C32.899 15.8762 32.4211 16.0846 32.0805 16.4514L28.1051 20.7326C27.6258 21.2488 27.4916 21.9971 27.7617 22.6477C27.9632 23.1329 28.0775 23.6583 28.0775 24.1928C28.0775 26.3727 26.3104 28.1398 24.1305 28.1398C21.9507 28.1398 20.1836 26.3728 20.1836 24.1928C20.1836 22.0129 21.9506 20.2459 24.1305 20.2459C24.5047 20.2459 24.8705 20.2974 25.2113 20.3917C25.8589 20.5708 26.5523 20.3743 27.0097 19.8821L31.5757 14.9682C31.8851 14.6352 32.0571 14.1975 32.0571 13.7429V10.59C32.0571 10.5784 32.0596 10.5632 32.0669 10.5464C32.0742 10.5295 32.0843 10.5159 32.0941 10.5067ZM40.1343 6.60411C40.1343 3.35678 36.2412 1.65662 33.8645 3.88989L32.304 5.36113C29.7672 4.22918 26.9569 3.59991 23.9996 3.59991C12.733 3.59991 3.59961 12.7333 3.59961 23.9999C3.59961 35.2665 12.733 44.3999 23.9996 44.3999C35.2662 44.3999 44.3996 35.2665 44.3996 23.9999C44.3996 20.9885 43.7471 18.1296 42.5758 15.5567L43.9741 14.0967L43.977 14.0937C46.254 11.7296 44.5601 7.80939 41.2975 7.80939H40.1343V6.60411ZM39.8457 18.4057C39.1446 19.1016 38.1976 19.4762 37.2377 19.4762H34.1845L31.4611 22.4091C31.6 22.9776 31.6775 23.5758 31.6775 24.1928C31.6775 28.3609 28.2986 31.7398 24.1305 31.7398C19.9624 31.7398 16.5836 28.3609 16.5836 24.1928C16.5836 20.0247 19.9624 16.6459 24.1305 16.6459C24.4406 16.6459 24.7482 16.6647 25.0511 16.7012L28.4571 13.0358V10.59C28.4571 9.65982 28.8088 8.77009 29.4217 8.09412C27.7207 7.51441 25.8969 7.19991 23.9996 7.19991C14.7212 7.19991 7.19961 14.7215 7.19961 23.9999C7.19961 33.2783 14.7212 40.7999 23.9996 40.7999C33.278 40.7999 40.7996 33.2783 40.7996 23.9999C40.7996 22.0385 40.4635 20.1556 39.8457 18.4057Z",
                fill: color
            })
        });
        $[0] = color;
        $[1] = t1;
    } else t1 = $[1];
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ jsx("defs", {
            children: /*#__PURE__*/ jsxs("filter", {
                id: "filter0_i_3982_59685",
                x: "2.59961",
                y: "2.87573",
                width: "42.4219",
                height: "42.5242",
                filterUnits: "userSpaceOnUse",
                colorInterpolationFilters: "sRGB",
                children: [
                    /*#__PURE__*/ jsx("feFlood", {
                        floodOpacity: "0",
                        result: "BackgroundImageFix"
                    }),
                    /*#__PURE__*/ jsx("feBlend", {
                        mode: "normal",
                        in: "SourceGraphic",
                        in2: "BackgroundImageFix",
                        result: "shape"
                    }),
                    /*#__PURE__*/ jsx("feColorMatrix", {
                        in: "SourceAlpha",
                        type: "matrix",
                        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                        result: "hardAlpha"
                    }),
                    /*#__PURE__*/ jsx("feOffset", {
                        dx: "-1",
                        dy: "1"
                    }),
                    /*#__PURE__*/ jsx("feGaussianBlur", {
                        stdDeviation: "0.5"
                    }),
                    /*#__PURE__*/ jsx("feComposite", {
                        in2: "hardAlpha",
                        operator: "arithmetic",
                        k2: "-1",
                        k3: "1"
                    }),
                    /*#__PURE__*/ jsx("feColorMatrix", {
                        type: "matrix",
                        values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.211765 0 0 0 0.12 0"
                    }),
                    /*#__PURE__*/ jsx("feBlend", {
                        mode: "normal",
                        in2: "shape",
                        result: "effect1_innerShadow_3982_59685"
                    })
                ]
            })
        });
        $[2] = t2;
    } else t2 = $[2];
    let t3;
    if ($[3] !== height || $[4] !== t1 || $[5] !== width) {
        t3 = /*#__PURE__*/ jsxs("svg", {
            width: width,
            height: height,
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                t1,
                t2
            ]
        });
        $[3] = height;
        $[4] = t1;
        $[5] = width;
        $[6] = t3;
    } else t3 = $[6];
    return t3;
};
export { Review3DIcon };
